import React, { useEffect, useState } from "react";
import { ModalForm, useStyles, FormInput, FormGroup, FormBox } from "../../../components";
import { CustomTable2 } from "../../../components/Tables2";
import { updateItemOption } from "../../../lib-pos";
import { ChevronD, ChevronU } from "../../../components/Icons";
import { optionTypes } from "./OkPosOptionMenus3";
import { targetLangs } from "../../../settings";
import { useInputFields } from "../../../lib/hooksLib";

import { getShortArray, isJson, sortObjArray2 } from "../../../lib/utils";
import { debug } from "../../../settings";

const headers = {
  // SDA
  SdaClsList: [
    { name: "selected", displayName: "선택", type: "checkbox", keyName: "SDA_CLS_CD" },
    // { name: "SDA_CLS_CD", displayName: "코드(SDA_CLS_CD)", selectKey: true },
    { name: "SDA_CLS_CD", displayName: "코드(SDA_CLS_CD)" },
    { name: "SDA_CLS_NM", displayName: "이름" },
    // { name: "USE_YN", displayName: "사용여부" },
    { name: "required", displayName: "필수여부", type: "boolean" },
  ],
  SdaCdList: [
    { name: "selected", displayName: "선택", type: "checkbox", keyName: "SDA_CD" },
    // { name: "SDA_CD", displayName: "코드(SDA_CD)", selectKey: true },
    { name: "SDA_CD", displayName: "코드(SDA_CD)" },
    { name: "SDA_CLS_CD", displayName: "분류코드(SDA_CLS_CD)" },
    { name: "SDA_NM", displayName: "이름" },
    { name: "isSoldout", displayName: "품절" },
  ],

  // SDS
  SdsClsList: [
    { name: "selected", displayName: "선택", type: "checkbox", keyName: "SDS_CLS_CD" },
    // { name: "SDS_CLS_CD", displayName: "코드(SDS_CLS_CD)", selectKey: true },
    { name: "SDS_CLS_CD", displayName: "코드(SDS_CLS_CD)" },
    { name: "SDS_CLS_NM", displayName: "이름" },
    { name: "required", displayName: "필수여부", type: "boolean" },
  ],
  SdsCdList: [
    { name: "selected", displayName: "선택", type: "checkbox", keyName: "SDS_CD" },
    // { name: "SDS_CD", displayName: "코드(SDS_CD)", selectKey: true },
    { name: "SDS_CD", displayName: "코드(SDS_CD)" },
    { name: "SDS_CLS_CD", displayName: "분류코드(SDS_CLS_CD)" },
    { name: "SDS_NM", displayName: "이름" },
    { name: "isSoldout", displayName: "품절" },
  ],
}

export function OKPosOptionSortingModal(props) {
  const {
    optionType, // SdsCls | SdsCd | SdaCls | SdaCd | sdsSortingCdListForCls
    sdaClsList, sdaCdList,
    sdsClsList, sdsCdList,
    selectedSdsCls, // 특정 sdsCls의 cdList sorting 데이터
    visible,
    setVisible,
    shopInfo,
    onload,
    isLoading, setIsLoading
  } = props;

  const { gStyle } = useStyles()

  // let modalTitle = "잘못된 접근입니다."

  // if (optionType === optionTypes.sdaCls) modalTitle = "속성분류 순서 세팅"
  // if (optionType === optionTypes.sdaCd) modalTitle = "속성항목 순서 세팅"
  // if (optionType === optionTypes.sdsCls) modalTitle = "선택분류 순서 세팅"
  // if (optionType === optionTypes.sdsCd) modalTitle = "선택항목 순서 세팅"

  // /** @cdList_for_sdsCls */
  // if (optionType === optionTypes.sdsSortingCdListForCls) modalTitle = "선택항목 순서 세팅"


  const [title, setTitle] = useState("잘못된 접근입니다.")
  const [tHeader, setTHeader] = useState([])
  const [optItems, setOptItems] = useState([])

  useEffect(() => {
    function start() {

      let optList = []

      if (optionType === optionTypes.sdaCls) {
        optList = sdaClsList.map(o => {
          return { ...o, required: o.required || false }
        })
        setTHeader(headers.SdaClsList)
        setTitle("속성분류 순서 세팅")
      }

      if (optionType === optionTypes.sdaCd) {
        optList = sdaCdList.map(o => {
          return { ...o, isSoldout: o.isSoldout ? o.isSoldout : false }
        })
        setTHeader(headers.SdaCdList)
        setTitle("속성항목 순서 세팅")
      }

      if (optionType === optionTypes.sdsCls) {
        if (debug) console.log('optionType', optionType)
        optList = sdsClsList.map(o => {
          return { ...o, required: o.required || false }
        })
        setTHeader(headers.SdsClsList)
        setTitle("선택분류 순서 세팅")
      }

      if (optionType === optionTypes.sdsCd) {
        optList = sdsCdList.map(o => {
          return { ...o, isSoldout: o.isSoldout ? o.isSoldout : false }
        })
        setTHeader(headers.SdsCdList)
        setTitle("선택항목 순서 세팅")
      }

      if (optionType === optionTypes.sdsSortingCdListForCls) {
        const selectedCdList = sdsCdList.filter(cd => cd["SDS_CLS_CD"] === selectedSdsCls["SDS_CLS_CD"])
        const optList0 = selectedCdList.map(o => {
          return { ...o, isSoldout: o.isSoldout ? o.isSoldout : false }
        })
        optList = sortObjArray2({arr: optList0, key: "sortOrder"})

        if (debug) {
          console.table(optList0)
          console.table(optList)
        }
        setTHeader(headers.SdsCdList)
        setTitle("선택항목 순서 세팅 - " + (selectedSdsCls?.SDS_CLS_NM || ""))
      }

      setOptItems(optList)
    }
    start()
  }, [
    optionType,
    sdaClsList,
    sdaCdList,
    sdsClsList,
    sdsCdList,
    selectedSdsCls
  ])

  const onSubmit = async () => {
    try {
      setIsLoading(true)

      //
      // sorting sdsCdList by selectedSdsCdList
      // 
      if (optionType === optionTypes.sdsSortingCdListForCls) {

        // sortOrder 변경
        const newSelSdsCdList = optItems.map((cd, i) => {
          delete cd.selected
          return { ...cd, sortOrder: i }
        })

        const finalSdsCdList = _getSortedSdsCdList({ targetCdList: newSelSdsCdList, selectedSdsCls })
        if(debug){
          const newArr = getShortArray(finalSdsCdList, ["PROD_CD", "SDS_CD", "SDS_NM", "SDS_CLS_CD", "className", "sortOrder", "nameLang"])
          console.log("=".repeat(100), 'finalSdsCdList', newArr.length)
          console.table(newArr)
        }

        const params = {
          shopInfo,
          body: { SdsCdList: JSON.stringify(finalSdsCdList) }
        }
        let res0 = await updateItemOption(params)
        if (res0.err) throw Error(res0.err.message)
      }

      //
      // 전체 sorting
      // 
      else {
        const newList = optItems.map((obj, i) => {
          const obj2 = { ...obj, sortOrder: i }
          delete obj2.selected
          return obj2
        })

        if (debug) {
          console.log('='.repeat(50), optionType)
          console.table(newList)
        }
        // throw Error('test...')

        let body = {}

        // SDA
        if (optionType === optionTypes.sdaCls) body = { SdaClsList: JSON.stringify(newList) }
        if (optionType === optionTypes.sdaCd) body = { SdaCdList: JSON.stringify(newList) }

        // SDS
        if (optionType === optionTypes.sdsCls) body = { SdsClsList: JSON.stringify(newList) }
        if (optionType === optionTypes.sdsCd) body = { SdsCdList: JSON.stringify(newList) }

        let res = await updateItemOption({ shopInfo, body })
        if (res.err) throw Error(res.err.message)
      }

      await onload()
    } catch (e) {
      if (debug) console.log(e)
      alert(e.message);
    } finally {
      setIsLoading(false);
      setVisible(false);
    }
  }

  const _getSortedSdsCdList = ({ targetCdList, selectedSdsCls }) => {
    const selectedProdCodes = targetCdList.map(cd => cd["PROD_CD"])

    const sortedSelectedProdCodes = [...selectedProdCodes]
    sortedSelectedProdCodes.sort()

    if (debug) {
      console.log("=".repeat(100), selectedProdCodes.length)
      console.log('selectedCdCodes        ', selectedProdCodes)
      console.log('sortedSelectedProdCodes', sortedSelectedProdCodes)
    }

    const newSdsCdList = []

    for (let i = 0; i < sdsClsList.length; i++) {
      const cls = sdsClsList[i]

      const cdList = sdsCdList.filter(cd => cd["SDS_CLS_CD"] === cls["SDS_CLS_CD"])
      const prodCodes = cdList.map(cd => cd["PROD_CD"])
      const sortedProdCodes = [...prodCodes]
      sortedProdCodes.sort()

      if (JSON.stringify(sortedSelectedProdCodes) === JSON.stringify(sortedProdCodes)) {
        const newCdList = getSortedCdList(selectedProdCodes, cdList)
        newCdList.map((cd, j) => {
          const newSdsCd = {
            ...cd, 
            sortOrder: j,
          }
          if(debug) {
            newSdsCd.className = selectedSdsCls["SDS_CLS_NM"]
          }
          newSdsCdList.push(newSdsCd)
        })
        if (debug) {
          console.log("-".repeat(100), i, cls["SDS_CLS_NM"], cls["SDS_CLS_CD"], cdList.length)
          console.log('is same order?', JSON.stringify(selectedProdCodes) === JSON.stringify(newCdList.map(cd => cd["PROD_CD"])))
        }
      }
      else {
        cdList.map(cd => {
          newSdsCdList.push(cd)
        })
      }
    }
    return newSdsCdList
  }

  const getSortedCdList = (prodCodeList, cdList) => {
    const newCdList = prodCodeList.map(prodCode => {
      const idx = cdList.findIndex(obj => obj["PROD_CD"] === prodCode)
      return cdList[idx]
    })
    return newCdList
  }

  const onMove = (direction) => {
    // const newItems = [...sdsClasses]
    const newItems = [...optItems]

    let idx = newItems.findIndex(item => item.selected)
    if (idx < 0) return null
    const obj = newItems[idx]

    newItems.splice(idx, 1)
    if (direction === "up") {
      idx = idx === 0 ? idx : --idx
    } else {
      idx = idx === newItems.length ? idx : ++idx
    }
    newItems.splice(idx, 0, obj)
    // setSdsClasses(newItems)
    setOptItems(newItems)
  }

  const styles = {
    formGroup: { margin: "15px 5px" }
  }

  return (
    <ModalForm
      visible={visible}
      setIsVisible={setVisible}
      title={title}
      isLoading={isLoading}
      onSubmit={onSubmit}
      size={"lg"}
      backdrop="static"
    >
      <div style={styles.formGroup}>
        {/* <p style={gStyle.text}>아이템을 클릭하면 필수여부가 변경됩니다.</p> */}
        <div style={{
          display: "flex",
          justifyContent: "space-between", alignItems: "center",
          margin: 5
        }}>
          <p style={{ ...gStyle.text }}>편집 후 확인을 누르세요.</p>
          <div style={{
            border: "1px solid #ddd",
            borderRadius: 5,
            padding: "5px 10px",
            display: "flex",
            justifyContent: "space-between", alignItems: "center"
          }}>
            <p style={{ ...gStyle.text, marginRight: 5 }}><ChevronU onClick={() => onMove("up")} /></p>
            <p style={{ ...gStyle.text }}><ChevronD onClick={() => onMove("down")} /></p>
          </div>
        </div>

        <CustomTable2
          tableHeader={tHeader}
          rowItems={optItems}
          setRowItems={setOptItems}
        />
      </div>
    </ModalForm>
  )
}

export function OKPosOptionEditModal(props) {
  const {
    shopInfo,
    optionType, // SdsCls | SdsCd | SdaCls | SdaCd
    sdaClsList, sdaCdList,
    sdsClsList, sdsCdList,
    visible, setVisible,
    editItem,
    onload,
  } = props

  const { gStyle } = useStyles()

  let modalTitle = "옵션 편집"
  let optName = ""

  if (optionType === optionTypes.sdsCls) optName = editItem.SDS_CLS_NM
  if (optionType === optionTypes.sdsCd) optName = editItem.SDS_NM
  if (optionType === optionTypes.sdaCls) optName = editItem.SDA_CLS_NM
  if (optionType === optionTypes.sdaCd) optName = editItem.SDA_NM

  const supportedLangs = props.itemOptions3?.menuSettings?.supportedLangs || [];
  const nameLang = editItem.nameLang || {}

  const defaultNameLangFields = {}
  targetLangs.map((lang) => {
    if (supportedLangs.includes(lang.name)) {
      // console.log(lang.name, nameLang[lang.name])
      defaultNameLangFields[lang.name] = nameLang[lang.name] || ""
    }
    return null;
  })

  const [isLoading, setIsLoading] = useState(false)

  const [nameLangFields, setNameLangFields] = useInputFields(defaultNameLangFields)
  const [isSoldout, setIsSoldout] = useState(editItem.isSoldout || false)
  const [required, setRequired] = useState(editItem.required || false)

  const onSubmit = async () => {
    try {
      setIsLoading(true)
      let res = {}
      if (optionType === optionTypes.sdsCls) res = await sdsCls()
      if (optionType === optionTypes.sdsCd) res = await sdsCd()
      if (optionType === optionTypes.sdaCls) res = await sdaCls()
      if (optionType === optionTypes.sdaCd) res = await sdaCd()
      if (res.err) throw Error(res.err.message)

      await onload()
    } catch (e) {
      alert(e.message)
    } finally {
      setIsLoading(false)
      setVisible(false)
    }
  }

  const sdsCls = async () => {
    try {

      const newList = sdsClsList.map(cls => {
        if (cls.SDS_CLS_CD === editItem.SDS_CLS_CD) {
          const newSdsCls = { ...editItem }
          delete newSdsCls.selected
          newSdsCls.nameLang = nameLangFields
          newSdsCls.required = required
          return newSdsCls
        } else {
          return cls
        }
      })

      let res = await updateItemOption({ shopInfo, body: { SdsClsList: JSON.stringify(newList) } })
      if (res.err) throw Error(res.err.message)
      return {}
    } catch (e) {
      return { err: { message: e.message } }
    }
  }

  const sdsCd = async () => {
    try {

      const newList = sdsCdList.map(cd => {
        // if (cd.SDS_CD === editItem.SDS_CD) {
        //   const newSdsCd = { ...editItem }
        //   newSdsCd.nameLang = nameLangFields
        //   newSdsCd.isSoldout = isSoldout
        //   return newSdsCd
        // } else {
        //   return cd
        // }

        /** @동일한_PROD은_모두_적용 */
        if (cd.PROD_CD === editItem.PROD_CD) {
          const newSdsCd = { ...cd }  // 기존 cd 정보 카피
          newSdsCd.nameLang = nameLangFields
          newSdsCd.isSoldout = isSoldout
          return newSdsCd
        } else {
          return cd
        }
      })

      // const sameCds = newList.filter(cd=>cd.PROD_CD===editItem.PROD_CD)
      // console.table(sameCds)
      // throw Error('test...')

      let res = await updateItemOption({ shopInfo, body: { SdsCdList: JSON.stringify(newList) } })
      if (res.err) throw Error(res.err.message)
      return {}
    } catch (e) {
      return { err: { message: e.message } }
    }
  }

  const sdaCls = async () => {
    try {

      const newList = sdaClsList.map(cd => {
        if (cd.SDA_CLS_CD === editItem.SDA_CLS_CD) {
          const newSdaCls = { ...editItem }
          newSdaCls.nameLang = nameLangFields
          newSdaCls.required = required
          return newSdaCls
        } else {
          return cd
        }
      })

      let res = await updateItemOption({ shopInfo, body: { SdaClsList: JSON.stringify(newList) } })
      if (res.err) throw Error(res.err.message)
      return {}
    } catch (e) {
      return { err: { message: e.message } }
    }
  }

  const sdaCd = async () => {
    try {

      const newList = sdaCdList.map(cd => {
        if (cd.SDA_CD === editItem.SDA_CD) {
          const newSdaCd = { ...editItem }
          newSdaCd.nameLang = nameLangFields
          newSdaCd.isSoldout = isSoldout
          return newSdaCd
        } else {
          return cd
        }
      })

      let res = await updateItemOption({ shopInfo, body: { SdaCdList: JSON.stringify(newList) } })
      if (res.err) throw Error(res.err.message)

      return {}
    } catch (e) {
      return { err: { message: e.message } }
    }
  }

  const styles = {
    title: { ...gStyle.subtitle, fontWeight: "bold" },
    text: { ...gStyle.text, marginBottom: "3px" },
  };

  return (
    <ModalForm
      visible={visible}
      setIsVisible={setVisible}
      title={modalTitle}
      isLoading={isLoading}
      onSubmit={onSubmit}
      size={"md"}
      backdrop="static"
    >
      <p style={styles.title}>옵션명: {optName}</p>

      {(supportedLangs.length) > 0 &&
        <FormGroup>
          <p style={styles.text}>언어별 메뉴명 편집</p>
          <FormBox>
            {
              targetLangs.map((lang, i) => {
                if (supportedLangs.includes(lang.name)) {
                  return (
                    <FormInput
                      key={lang.name}
                      label={lang.displayName}
                      name={lang.name}
                      value={nameLangFields[lang.name]}
                      onChange={setNameLangFields}
                    />
                  )
                } else return null
              })
            }
          </FormBox>
        </FormGroup>
      }

      {(optionType === optionTypes.sdsCd || optionType === optionTypes.sdaCd) &&
        <FormGroup>
          <FormBox>
            <FormInput
              label="품절 여부"
              name="isSoldout"
              checked={isSoldout}
              onChange={() => setIsSoldout(!isSoldout)}
              inputType="checkbox"
            />
          </FormBox>
        </FormGroup>
      }

      {(optionType === optionTypes.sdsCls || optionType === optionTypes.sdaCls) &&
        <FormGroup>
          <FormBox>
            <FormInput
              label="필수 여부"
              name="required"
              checked={required}
              onChange={() => setRequired(!required)}
              inputType="checkbox"
            />
          </FormBox>
        </FormGroup>
      }
    </ModalForm>
  )
}